import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';

const swioer = require('../../lib/js/swiper/swiper.min.js');
// const remodal = require('../../lib/js/remodal/remodal.min.js');
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
	// console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
// let param = {
// 	target:'#spnavi',
// 	trigger:'.btn_sp_navi',
// 	filter:'resposive_flg',
// 	speed:200
// };
// const spnavi = new SpNavi(param);
// spnavi.exec();

$(".btn_sp_navi_wrap").on("click",function(){
	$("#spnavi").fadeToggle();
	$("a",this).toggleClass("active");
	$("body").toggleClass("ovh");
});

/* ===============================================
gNAv gotop
=============================================== */
$(window).on("scroll",function(){
	var wh = $(window).scrollTop();
	if(wh >90){
		$(".gNav").addClass("fixed");
		$(".gotop").fadeIn();
	}else{
		$(".gNav").removeClass("fixed");
		$(".gotop").fadeOut();
	}
});

/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();

/* ===============================================
aboutus
=============================================== */
$(".aboutUs_btn").on("click",function(){
	console.log("ok");
	$(this).toggleClass("active");
	$(".aboutUs_inner").toggleClass("active");
});

/* ===============================================
slide
=============================================== */
var mySwiper = new Swiper ('.mvHome', {
	// Optional parameters
	loop: true,
	speed:500,
	autoplay:3000,
	effect:"fade"
});

$(".hasChild").hover(function(){
		$(this).find(".child").stop().fadeIn();
		// $(".child",this).fadeIn();
		console.log("on");
	},function(){
		$(this).find(".child").stop().fadeOut();
	}
);

/* ===============================================
entryLists-home
=============================================== */
var items = $(".entryLists_item").length;
if(items < 7){
	$(".entryLists_bg02").hide();
}

//category list
// $(window).on("load resize",function(){
// 	if($(".catListWrap")){
// 		// if(r.state()()){
// 		// 	var catListY = $(".catListWrap").offset().top;
// 		// 	var liY = $(".catList li").eq(6).offset().top;
// 		// 	console.log(catListY);
// 		// 	console.log(liY);
// 		// 	var result = liY - catListY + 50;
// 		// 	$(".catList").css("height",result);
// 		// }else{
// 		// 	$(".catList").css("height","auto");
// 		// }
// 	}
// });


// $(".btnToggle").on("click",function(){
// 	$(".catList ul").animate({"height":"auto"},500);
// });

/* ===============================================
interview
=============================================== */
var interviewSlide = new Swiper ('.interviewSlide', {
	// Optional parameters
	loop: true,
	// speed:500,
	autoplay:4000,
	slidesPerView:2,
	spaceBetween:40,
	nextButton: '.interviewPager_next',
	prevButton: '.interviewPager_prev',
	autoHeight:true,
	breakpoints: {
		600:{
			slidesPerView:1,
			spaceBetween:0,
		}
	}
});

/* ===============================================
sudent articles
=============================================== */
$(".articles_trigger").on("click",function(){
	console.log("ok");
	$(this).parents(".articles").toggleClass("opened");
	$(this).parent(".articles_header").next(".articles_detail").slideToggle();
});

/* ===============================================
solution
=============================================== */
var questionSlide = new Swiper ('.questionSlide', {
	loop: true,
	slidesPerView:2,
	spaceBetween:44,
	nextButton: '.questionPager_next',
	prevButton: '.questionPager_prev',
	breakpoints: {
		600:{
			slidesPerView:1,
			spaceBetween:100,
		}
	}
});

/* ===============================================
faq
=============================================== */
$(".faqList dt").on("click",function(){
	$(this).next("dd").slideToggle();
	$(this).toggleClass("opened");
});


/* ===============================================
anchorList
=============================================== */
$(window).on("load resize",function(){
	var ul_h = $(".anchorList").height();
	var li_h = $(".anchorList li").height() + parseInt($(".anchorList li").css("margin-bottom"),10);

	if(ul_h > li_h){
		$(".anchorList").addClass("al");
		console.log("2行");
	}else{
		$(".anchorList").removeClass("al");
	}
});



// WEBPACK FOOTER //
// ./js/scripts/main.js